import React from 'react';
import { careersPageData } from './markup'
import Index from '../index'

export default ({ location }) => {
  return (<Index pageData={careersPageData} location={location} />)
}